import { ZodError, ZodType } from "zod";

export type ZodErrorInfo = {
  object: any;
  zodError: ZodError;
  zodType: any;
};

/**
 * JSON form of a ZodError, as API error responses expose it. zod 3 serialized a ZodError as
 * { issues, name }, zod 4 as { name, message }; this keeps the zod 3 shape for API clients.
 */
export function zodErrorToJSON(error: ZodError) {
  return { issues: error.issues, name: error.name };
}

export class ExtendedZodError extends Error {
  public info: ZodErrorInfo;

  constructor(info: ZodErrorInfo) {
    super(JSON.stringify({ ...info, zodError: zodErrorToJSON(info.zodError) }));
    this.info = info;
  }
}

export function zParse<T>(z: ZodType<T>, obj: any): T {
  const res = z.safeParse(obj);
  if (res.success) {
    return res.data;
  } else {
    throw new ExtendedZodError({
      object: obj,
      zodError: res.error,
      zodType: z.description,
    });
  }
}
